'use client'

import {
  referencesProductArticleDetailShownAtom,
  referencesProductFiltersEnrichedAtom,
  referencesProductSelectableColumnsAtom,
  referencesProductSelectedColumnsAtom,
} from '@/feature/product/services/referencesProduct.store'
import { useResetAtom } from 'jotai/utils'
import { useEffect } from 'react'

export function ProductPageResetAtoms() {
  const resetSelectableColumns = useResetAtom(referencesProductSelectableColumnsAtom)
  const resetSelectedColumns = useResetAtom(referencesProductSelectedColumnsAtom)
  const resetReferencesProductFiltersEnriched = useResetAtom(referencesProductFiltersEnrichedAtom)
  const resetReferencesProductArticleDetailShown = useResetAtom(
    referencesProductArticleDetailShownAtom,
  )

  useEffect(() => {
    return () => {
      resetSelectedColumns()
      resetSelectableColumns()
      resetReferencesProductFiltersEnriched()
      resetReferencesProductArticleDetailShown()
    }
  }, [
    resetSelectedColumns,
    resetSelectableColumns,
    resetReferencesProductFiltersEnriched,
    resetReferencesProductArticleDetailShown,
  ])

  return null
}
